import React from 'react';
import { anchorate } from 'anchorate';
import { emitter } from '@marvelapp/react-ab-test';
import { MarkupProvider } from 'providers/MarkupProvider';
import {
  MEGA_MENU_ACTIVE_VARIANT_NAMES,
  MEGA_MENU_EXPERIMENT_NAME,
} from 'components/NavBar/subcomponents/Menu/megaMenuAbVariants';

let megaMenuAbTrackingInitialized = false;

const prepareMegaMenuExperiment = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const storageKey = `PUSHTELL-${MEGA_MENU_EXPERIMENT_NAME}`;
  const storedVariant = window.localStorage.getItem(storageKey);

  // Reassign users stuck on retired A/B (pre–Design & UX) so the menu still renders.
  if (
    storedVariant &&
    !MEGA_MENU_ACTIVE_VARIANT_NAMES.includes(storedVariant)
  ) {
    window.localStorage.removeItem(storageKey);
  }

  emitter.defineVariants(
    MEGA_MENU_EXPERIMENT_NAME,
    MEGA_MENU_ACTIVE_VARIANT_NAMES,
  );
};

const initMegaMenuAbTracking = () => {
  if (megaMenuAbTrackingInitialized || typeof window === 'undefined') {
    return;
  }

  megaMenuAbTrackingInitialized = true;

  emitter.addPlayListener((experimentName, variantName) => {
    if (experimentName !== MEGA_MENU_EXPERIMENT_NAME) {
      return;
    }

    if (!MEGA_MENU_ACTIVE_VARIANT_NAMES.includes(variantName)) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ab_experiment_impression',
      experiment_name: experimentName,
      experiment_variant: variantName,
    });
  });
};

export const onRouteUpdate = () => {
  anchorate();
};

export const onClientEntry = () => {
  // The blog search index (public/search-index.json) is prefetched by the
  // views that render a SearchBar (blog PostList, ArticleContent) rather than
  // here, so non-blog pages do not download and parse a multi-MB JSON blob.
  prepareMegaMenuExperiment();
  initMegaMenuAbTracking();
};

export const wrapRootElement = ({ element }) => {
  return (
    <MarkupProvider>
      {element}
    </MarkupProvider>
  );
};
